import moment from "moment";
import { Column } from "react-table";
import { InvoiceItem } from "../models/InvoiceItem";
import { DataGrid } from "./common/DataGrid";
import { Checkbox, Icon } from "semantic-ui-react";

interface Props {
  invoiceItems?: InvoiceItem[] | null;
  pageCount?: number;
  onPageInfoChange: (pageSize: number, pageIndex: number) => void;
  onInvoiceItemSelectChange: (id: string, checked: boolean) => void;
  selectedInvoiceItems: string[];
}

const AdminInvoiceItemsGrid = ({
  invoiceItems,
  pageCount,
  onPageInfoChange,
  onInvoiceItemSelectChange,
  selectedInvoiceItems,
}: Props) => {
  const columns: Column<InvoiceItem>[] = [
    {
      Header: "",
      id: "selector",
      accessor: (i) => (
        <Checkbox
          checked={selectedInvoiceItems.includes(i.id)}
          onChange={(e, data) => onInvoiceItemSelectChange(i.id, !!data.checked)}
        ></Checkbox>
      ),
    },
    {
      Header: "Organization",
      id: "organization",
      accessor: (i) => i.organization.name,
    },
    {
      Header: "Start date",
      id: "startDate",
      accessor: (i) => moment(i.startDate).format("L"),
    },
    {
      Header: "End date",
      id: "endDate",
      accessor: (i) => moment(i.endDate).format("L"),
    },
    {
      Header: "Amount",
      id: "amount",
      accessor: (i) =>
        new Intl.NumberFormat("en-GB", {
          style: "currency",
          currency: "GBP",
        }).format(i.amount),
    },
    {
      Header: "Sent",
      id: "sent",
      accessor: (i) => (i.sent ? <Icon name="check" /> : <Icon name="times" />),
    },
  ];

  return (
    <>
      <DataGrid
        columns={columns}
        data={invoiceItems ? invoiceItems : []}
        onPageInfoChange={onPageInfoChange}
        loading={false}
        pageCount={pageCount}
      />
    </>
  );
};

export default AdminInvoiceItemsGrid;
